<div class="customize-container pt-1">
  <div class="row">
    <div class="col-sm-12 offset-md-2 col-md-8 offset-lg-2 col-lg-8 pt-4">
      <div>
        <form role="form" [formGroup]="coverageTermsForm">
          <div class="row">
            <div class="col-sm-12 coverage-section">
              <div class="pt-1 pr-3 choose-terms-section" [ngClass]="{'with-commerical': chosenPlan?.plan.commercialUse || chosenPlan?.plan.liftKit || chosenPlan?.plan.snowPlow || chosenPlan?.plan.greyMarket}">
                <div class="p-2">
                  <div class="w-100">
                    @if (showNCESITerm) {
                      <div>
                        <h2 tabindex="0" id="termlength" class="active ncesi-term-length"
                          aria-label="{{ 'RATES_PAGE.CHOOSE_ENDS' | translate }}">{{ 'RATES_PAGE.CHOOSE_ENDS' | translate }}**
                        </h2>
                        @if (isBrand !== 'MINI' && isBrand !== 'BMW') {
                          <div class="term-length-sub">{{ 'RATES_PAGE.COVERAGE_EXP' | translate }}</div>
                        }
                        <div class="md-form terms-select">
                          <select role="listbox" class="form-control" aria-labelledby="termlength"
                            formControlName="terms" id="coverageTermSelect" (change)="updatePricing()">
                            @for (term of chosenPlan?.planTerms; track term) {
                              <option
                                value="{{term.value}}">
                                {{convertTermLabel(term.label)}}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                    }
                    @if (!showNCESITerm) {
                      <div class="md-form terms-div">
                        <label tabindex="0" id="termlength" class="active"
                          aria-label="{{ 'RATES_PAGE.CHOOSE_TERM' | translate }}">{{ 'RATES_PAGE.CHOOSE_TERM' | translate }}**
                        </label>
                        <select role="listbox" class="form-control" aria-labelledby="termlength"
                          formControlName="terms" id="coverageTermSelect" (change)="updatePricing()">
                          @for (term of chosenPlan?.planTerms; track term) {
                            <option
                              value="{{term.value}}">
                              {{convertTermLabel(term.label)}}
                            </option>
                          }
                        </select>
                      </div>
                    }
                  </div>
                  @if (showNCESITerm) {
                    <div class="text-center mb-5 desktop">
                      <span class="estimated-coverage-text">{{ 'RATES_PAGE.' | translate }}: </span>
                      <span class="estimated-coverage-terms"> {{expireDate | date: 'longDate' : preferredLanguage}} {{ 'RATES_PAGE.OR' | translate }} {{expireMileage}} {{mileage}}</span>
                    </div>
                  }
                  @if (showNCESITerm) {
                    <div class="text-center mb-5 mobile">
                      <div class="estimated-coverage-text">{{ 'RATES_PAGE.' | translate }}: </div>
                      <div class="estimated-coverage-terms"> {{expireDate | date: 'longDate' : preferredLanguage}} {{ 'RATES_PAGE.OR' | translate }} {{expireMileage}} {{mileage}}</div>
                    </div>
                  }

                </div>
              </div>
            </div>
          </div>
          <div class="term-statement" tabindex="0">
            **{{setTooltip(chosenPlan?.product.productCode)}}
          </div>
          <div class="col-12 text-center mb-3 mt-3 desktop">
            <button mdbBtn id="addToCartButton" class="btn primary-btn waves-light" mdbWavesEffect (click)="addToCart()">
              <span>
                {{ 'RATES_PAGE.ADD_TO_CART' | translate }}
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
